export default __webpack_public_path__ + "static/media/3.9e0fbc77.png";